import classNames from 'classnames';
import * as React from 'react';
import './index.scss';

interface CustomImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  mode?: string;
}

const CustomImage = React.forwardRef<HTMLImageElement, CustomImageProps>((props, ref) => {
  return <img {...props} ref={ref} alt={props.alt || ''} />;
});

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

export const Image: React.FC<ImageProps> = (props) => {
  const { className } = props;

  return (
    <CustomImage
      {...props}
      alt={props.alt}
      className={classNames('image', className)}
      mode='widthFix'
    />
  );
};
